module.exports = __webpack_public_path__ + "img/Cranberry Concentrate.86d7ac7d.png";